<div class="center-content-area">
    <h2 class="center-page-heading">{{ "settings_apps_download_heading" | translate }}</h2>
    <p class="center-page-description">{{ "settings_apps_download_description" | translate }}</p>

    <div class="flex flex-row flex-md-row mb-12">
        <div class="mx-2 my-12">
            <p-card
                header="{{ 'settings_apps_download_desktop_heading' | translate }}"
                subheader="{{ 'settings_apps_download_desktop_subheading' | translate }}"
                class="settings-card card-image-header"
            >
                <ng-template pTemplate="header">
                    <img class="w-full" alt="Card" src="/assets/images/pages/integration/timeBuzzer-desktop-app.png" />
                </ng-template>
                <p>{{ "settings_apps_download_desktop_description" | translate }}</p>
                <ng-template pTemplate="footer">
                    <p-button label="Windows" icon="pi pi-microsoft" (click)="downloadAppWin()"></p-button>
                    <p-button label="MacOS" icon="pi pi-apple" [style]="{ 'margin-left': '.5em' }" (click)="downloadAppMac()"></p-button>
                    <p-button label="Linux" icon="pi pi-download" [style]="{ 'margin-left': '.5em' }" (click)="downloadAppLinux()"></p-button>
                </ng-template>
            </p-card>
        </div>
        <div class="mx-2 my-12">
            <p-card
                header="{{ 'settings_apps_download_mobile_heading' | translate }}"
                subheader="{{ 'settings_apps_download_mobile_subheading' | translate }}"
                class="settings-card card-image-header"
            >
                <ng-template pTemplate="header">
                    <img class="w-full" alt="Card" src="/assets/images/pages/integration/timeBuzzer-mobile-app.png" />
                </ng-template>
                <p>{{ "settings_apps_download_mobile_description" | translate }}</p>
                <ng-template pTemplate="footer">
                    <p-button label="iOS" icon="pi pi-apple" (click)="showDialogApple()"></p-button>
                    <p-button label="Android" icon="pi pi-android" [style]="{ 'margin-left': '.5em' }" (click)="showDialogAndroid()"></p-button>
                </ng-template>
            </p-card>
        </div>
    </div>
</div>

<p-dialog header="{{ 'settings_apps_mobile_dialog_android_title' | translate }}" [(visible)]="displayDialogAndroid" [baseZIndex]="10000">
    <img src="/assets/images/timeBuzzer_android.svg" alt="Image" width="250" />
    <br />
    <p style="text-align: center">
        {{ "settings_apps_mobile_dialog_android_content" | translate }}<br /><br />
        <a href="{{ 'settings_apps_mobile_playstore_link' | translate }}" target="_blank" rel="noopener">{{ "settings_apps_mobile_playstore" | translate }}</a>
    </p>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (onClick)="displayDialogAndroid = false" label="{{ 'standard_done' | translate }}" styleClass="p-button" iconPos="right">
        </p-button>
    </ng-template>
</p-dialog>

<p-dialog header="{{ 'settings_apps_mobile_dialog_apple_title' | translate }}" [(visible)]="displayDialogApple" [baseZIndex]="10000">
    <img src="/assets/images/timeBuzzer_ios.svg" alt="Image" width="250" />
    <br />
    <p style="text-align: center">
        {{ "settings_apps_mobile_dialog_apple_content" | translate }}<br /><br />
        <a href="{{ 'settings_apps_mobile_appstore_link' | translate }}" target="_blank" rel="noopener">{{ "settings_apps_mobile_appstore" | translate }}</a>
    </p>

    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (onClick)="displayDialogApple = false" label="{{ 'standard_done' | translate }}" styleClass="p-button" iconPos="right">
        </p-button>
    </ng-template>
</p-dialog>
